{
  "currentActivity": "Activité actuelle",
  "online": "en ligne",
  "active": "actifs",
  "deviceMarkerUpdating": "Mise à jour...",
  "doNotShowThisAgain": "Ne plus afficher ceci",
  "inFieldWithFieldName": "Dans le champ ${{fieldName}}",
  "locateDevice": {
    "helpBody": "Pour être localisé, un appareil doit être sous tension et disposer d'une réception cellulaire.",
    "coordinatesWithLongitudeAndLatitude": "Coordonnées : {{longitude}}, {{latitude}}",
    "copyLocation": "Copie",
    "goTo": "Aller à",
    "linkTo": "Situer",
    "noLocationMessage": "Cet appareil ne dispose pas de localisation GPS. Veuillez vous assurer qu'il est allumé et qu'il dispose d'une réception cellulaire.",
    "noLocationTitle": "Pas de localisation GPS",
    "openInApple": "Ouvrir dans Apple Maps",
    "openInGoogleMaps": "Ouvrir dans Google Maps",
    "title": "Emplacement de l'appareil"
  },
  "locateDeviceCooordinatesLabel": "Coordonnées",
  "locateField": {
    "appleMaps": "Aller à (Apple Maps)",
    "errorMessage": {
      "message": "Impossible de calculer le centre du champ. Veuillez contacter le support.",
      "title": "Quelque chose s'est mal passé"
    },
    "googleMaps": "Aller à (Google Maps)"
  },
  "mapSettingsFieldColor": "Couleur du champ",
  "mapSettingsMapTypeId": "Style de carte",
  "mapSettingsTitle": "Paramètres de la carte",
  "quickActions": {
    "connectDevices": "Connecter des appareils",
    "createField": "Nouveau champ",
    "manageSchedules": "Gérer les horaires",
    "mapSettings": "Paramètres de la carte",
    "newDevice": "Nouvel appareil",
    "title": "Actes",
    "viewDeviceActivity": "Afficher l'activité de l'appareil",
    "viewSchedules": "Voir les horaires"
  },
  "selectedDevice": {
    "commandsLink": "Contrôles",
    "deviceProfileLink": "Gérer",
    "notifications": "Notifications"
  },
  "selectedReelRunTitle": "Course de bobine",
  "setReelDistance": {
    "distanceMmCurrent": {
      "errors": {
        "max": "Cette valeur est trop élevée par rapport au seuil autorisé pour les remplacements manuels de distance"
      },
      "labelWithUnitLabel": "Distance restante ({{unitLabel}})"
    },
    "distanceMmMax": {
      "labelWithUnitLabel": "Distance étendue ({{unitLabel}})"
    },
    "errorMessage": "Notre service ne peut pas traiter votre demande pour le moment. Veuillez réessayer.",
    "instructions": "Remplacer les distances de course ?",
    "linkTo": "Définir la distance",
    "noActiveRunsMessage": "Aucune bobine active n'a été trouvée pour cet appareil.",
    "noActiveRunsTitle": "Pas de course de bobine active",
    "notRetractingMessage": "Impossible de régler la distance d'une bobine qui n'est pas en rétraction.",
    "successMessage": "Modifications enregistrées. Veuillez patienter pour une mise à jour...",
    "title": "Définir la distance de la bobine",
    "warning": "Cela ne peut pas être annulé"
  },
  "setRunDirection": {
    "flipButton": "Retourner",
    "instructions": "Remplacer le sens de la course ?",
    "linkTo": "Définir la direction",
    "title": "Définir le sens de rotation de la bobine"
  },
  "setApplicationType": {
    "instructions": "Qu'a appliqué ce passage ? Ceci remplace le type d'application de la configuration de l'enrouleur pour ce passage uniquement.",
    "linkTo": "Définir le type d'application",
    "title": "Définir le type d'application du passage"
  },
  "setRunField": {
    "automaticOption": "Automatique (GPS)",
    "instructions": "Attribuez ce passage à un champ. Automatique utilise le point final GPS du passage ; choisir un champ épingle le passage à ce champ et utilise le sens des rangs de ce champ.",
    "linkTo": "Définir le champ",
    "title": "Définir le champ du passage"
  },
  "manageReelRun": "Gérer le passage de l'enrouleur",
  "deviceActivityHide": "Masquer l'activité",
  "deviceActivityLabel": "Activité",
  "deviceActivityShow": "Afficher l'activité",
  "heatmapLayersHide": "Masquer la carte thermique",
  "heatmapLayersLabel": "Carte thermique",
  "heatmapLayersShow": "Afficher la carte thermique",
  "heatmapLegendTitle": "Application Depth - Last 7 Days",
  "showDevices": "Appareils",
  "showFields": "Champs",
  "showReelRuns": "Bobines de tournage",
  "showTimeline": "Chronologie",
  "title": "Carte d'état",
  "unknownDevice": "Appareil inconnu",
  "unknownFields": {
    "description": "Les passages de bobines ne seront pas visibles à moins qu'ils ne se trouvent à l'intérieur des limites de l'un de vos champs.",
    "dismissButton": "Pas maintenant",
    "drawFieldButton": "Bouton de dessin de champ",
    "title": "Champs inconnus",
    "warningText": "FarmHQ a reçu des bobines pour les appareils suivants dans des domaines inconnus :"
  }
}
